<div class="grid grid-cols-[minmax(0,1fr)_auto]">
  <div>
    <button
      [appEnabledByPolicy]="[policy.canUpdateElevated, disabled]"
      #errorMessagesDropdownButton
      id="errorMessagesDropdown"
      data-dropdown-toggle="errorMessageDropdownRadioHelper"
      class="text-white focus:ring-2 w-full focus:outline-none bg-amazone-gray border-amazone-gray hover:bg-gray-800 placeholder-gray-400 focus:ring-amazone-orange focus:border-amazone-orange font-medium rounded-lg text-sm px-4 py-2.5 text-center inline-flex items-center disabled:cursor-not-allowed"
      type="button"
      [ngClass]="unsavedChanges ? 'unsaved-field' : ''"
      appAgentAction
      agent="error-message-selection-toggle"
      businessObject="errorMessage"
      [businessId]="$safeNavigationMigration(selectedErrorMessage?.id)"
      action="toggle"
    >
      <div class="w-full grid grid-cols-6">
        <div class="col-span-5 text-start">
          @if (selectedErrorMessage && selectedErrorMessage.id) {
            {{ selectedErrorMessage.code }} - {{ selectedErrorMessage.headerOnTerminal }}
          } @else {
            No Error message selected
          }
        </div>
        <div class="flex justify-end items-center">
          <svg class="w-2.5 h-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m1 1 4 4 4-4"
            />
          </svg>
        </div>
      </div>
    </button>

    <div
      #errorMessageDropdownRadioHelper
      id="errorMessageDropdownRadioHelper"
      class="z-10 hidden divide-y rounded-lg shadow-sm bg-amazone-gray divide-gray-500"
    >
      <div class="p-3">
        <label for="input-error-message-search" class="sr-only">Search</label>
        <div class="relative">
          <div class="absolute inset-y-0 rtl:inset-r-0 start-0 flex items-center ps-3 pointer-events-none">
            <svg
              class="w-4 h-4 text-gray-300"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
              />
            </svg>
          </div>
          <input
            type="text"
            id="input-error-message-search"
            class="block w-full p-2 ps-10 text-sm border rounded-lg bg-gray-600 border-gray-500 placeholder-gray-400 text-white focus:ring-amazone-orange focus:border-amazone-orange"
            placeholder="Search error messages"
            [(ngModel)]="searchTerm"
            (keyup)="searchErrorMessages($event)"
          />
        </div>
      </div>
      <ul
        #scrollContainer
        class="p-3 space-y-1 overflow-y-auto py-2 max-h-96 text-sm text-gray-200"
        aria-labelledby="errorMessagesDropdown"
      >
        @for (message of errorMessages; track $index) {
          <li>
            <div class="flex p-2 rounded-sm hover:bg-gray-800">
              <div class="flex items-center h-5">
                <input
                  [id]="'errmsg-radio-' + $index"
                  [name]="radioGroupName"
                  type="radio"
                  [value]="message.id ?? ''"
                  [checked]="selectedErrorMessage?.id === message.id"
                  [disabled]="disabled"
                  class="w-4 h-4 focus:ring-amazone-orange ring-offset-amazone-orange focus:ring-offset-gray-700 text-amazone-orange focus:ring-2 bg-gray-600 border-gray-500"
                  (change)="onErrorMessageSelect(message)"
                />
              </div>
              <div class="ms-2 text-sm">
                <label [for]="'errmsg-radio-' + $index" class="font-medium text-gray-300">
                  <div>{{ message.code ?? 'N/A' }} - {{ message.headerOnTerminal }}</div>
                  <p [id]="'errmsg-radio-' + $index" class="text-xs font-normal text-gray-300">
                    {{ message.detailsOnTerminal?.replaceAll('\n', ' ') }}
                  </p>
                </label>
              </div>
            </div>
          </li>
        } @empty {
          <li class="p-2 text-center text-gray-300">No error messages found</li>
        }
      </ul>
    </div>
  </div>
  @if (showCreateErrorMessage) {
    <div class="flex justify-start ms-2">
      <button
        [appEnabledByPolicy]="[policy.canUpdateElevated, disabled]"
        [ngClass]="unsavedChanges ? 'unsaved-field' : ''"
        data-tooltip-target="tooltip-create-error-message"
        data-tooltip-placement="right"
        type="button"
        (click)="newErrorMessage.openModal()"
        class="cursor-pointer inline-flex items-center text-sm font-medium text-white bg-amazone-gray hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-amazone-orange rounded-lg px-3 py-2.5 hover:scale-110 transition-transform duration-200 ease-in-out disabled:cursor-not-allowed"
        appAgentAction
        agent="error-message-selection-create"
        businessObject="errorMessage"
        action="create"
      >
        <app-add></app-add>
      </button>
    </div>
    <div
      id="tooltip-create-error-message"
      role="tooltip"
      class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-amber-600 rounded-lg shadow-xs opacity-0 tooltip"
    >
      Create new error message
      <div class="tooltip-arrow" data-popper-arrow></div>
    </div>
  }
</div>
<app-create-error-message-modal
  #newErrorMessage
  (createErrorMessageTriggered)="onErrorMessageCreated($event)"
></app-create-error-message-modal>
